export const SessionRestoreStrategyConfig = Object.freeze({
  keycloakStorage: {
    kcToken: 'kc_token',
    kcRefreshToken: 'kc_refreshToken',
  },
  minValidity: 30,
  errorInit: {
    token: 'token-refresh',
  },
});
